import { useEffect, useState } from "react";
// Layout
import Header from "../../layout/Header/Header";
// Components
import Loader from "../../components/Loader/Loader";
import ContactContent from "./ContactContent/ContactContent";
//Styles
import styles from "./Contact.module.scss";

const Contact = () => {
  const [mapsLoaded, setMapsLoaded] = useState(false);

  useEffect(() => {
    const scriptTag = document.createElement("script");
    scriptTag.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&libraries=places&language=en`;
    scriptTag.addEventListener("load", () => setMapsLoaded(true));
    document.body.appendChild(scriptTag);
  }, []);

  return (
    <main>
      <Header />

      {!mapsLoaded && (
        <div className={styles.contactLoaderContainer}>
          <Loader />
        </div>
      )}

      {mapsLoaded && <ContactContent />}
    </main>
  );
};

export default Contact;
